import Link from 'next/link';

import { APP_ROUTES } from '@/shared/constants/navigation';

import { INLINE_LINK_CLASS } from '../../constants/link-class';
import { MCP_COMPETITOR_ROWS } from '../../constants/mcp-content';
import {
	SECTION_CLASS,
	SECTION_HEADING_CLASS,
	SECTION_LEAD_CLASS,
} from '../../constants/section-classes';
import { BinaryLogo, CompetitorLogo } from '../common/competitor-logo';

/** "How Binary's MCP compares" table against the other ATS MCP servers. */
export const McpComparisonSection = () => {
	return (
		<section className={SECTION_CLASS}>
			<div className="mx-auto max-w-4xl">
				<div className="mb-10 md:mb-12">
					<h2 className={SECTION_HEADING_CLASS}>How Binary&apos;s MCP compares</h2>
					<p className={SECTION_LEAD_CLASS}>
						Several ATS vendors now ship an MCP server. The differences are who can use it and what
						it can do. From vendor pricing and docs pages, checked October 2026.
					</p>
				</div>

				<div className="overflow-x-auto rounded-xl border border-border bg-background">
					<table className="w-full min-w-[640px] border-collapse text-left text-sm">
						<thead>
							<tr className="border-b border-border bg-accent/50">
								<th className="px-4 py-3 font-semibold text-primary">ATS</th>
								<th className="px-4 py-3 font-semibold text-primary">Who gets MCP</th>
								<th className="px-4 py-3 font-semibold text-primary">Access</th>
							</tr>
						</thead>
						<tbody>
							{MCP_COMPETITOR_ROWS.map((row, index) => (
								<tr
									key={row.name}
									className={`border-b border-border last:border-b-0 ${index === 0 ? 'bg-emerald-50/60' : ''}`}
								>
									<td className="whitespace-nowrap px-4 py-3 font-semibold text-primary">
										{row.href ? (
											<Link
												href={row.href}
												className="flex items-center gap-2.5 underline decoration-1 decoration-slate-300 underline-offset-4 hover:decoration-primary"
											>
												<CompetitorLogo
													slug={row.href.replace('/compare/', '')}
													name={row.name}
													size="sm"
												/>
												{row.name}
											</Link>
										) : (
											<span className="flex items-center gap-2.5">
												<BinaryLogo size="sm" />
												{row.name}
											</span>
										)}
									</td>
									<td className="px-4 py-3 text-slate-700">{row.availability}</td>
									<td className="px-4 py-3 text-slate-700">{row.access}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<p className="mt-6 text-center text-sm text-secondary md:text-base">
					<Link
						href={APP_ROUTES.ATS_WITH_MCP}
						className={INLINE_LINK_CLASS}
					>
						See every ATS with an MCP server, ranked
					</Link>
				</p>
			</div>
		</section>
	);
};
